<template>
  <VePlayerVideo
    v-if="isUsingVePlayer"
    :key="'veplayer'"
    :videoPlayerReady="videoPlayerReady"
    :isAnyPopupOpen="isAnyPopupOpen"
    :arena-id="arenaId"
    embedded
  >
    <template #overlay>
      <VideoToast :toast="betVideoToast" :source="arenaId" />
    </template>
  </VePlayerVideo>
  <TCVideoV1
    v-else-if="isUsingV1Video"
    :key="'tcvideov1'"
    :videoPlayerReady="videoPlayerReady"
    :isAnyPopupOpen="isAnyPopupOpen"
    :arena-id="arenaId"
    embedded
  >
    <template #overlay>
      <VideoToast :toast="betVideoToast" :source="arenaId" />
    </template>
  </TCVideoV1>
  <TCVideo
    v-else
    :key="'tcvideo'"
    :videoPlayerReady="videoPlayerReady"
    :isAnyPopupOpen="isAnyPopupOpen"
    :arena-id="arenaId"
    embedded
  >
    <template #overlay>
      <VideoToast :toast="betVideoToast" :source="arenaId" />
    </template>
  </TCVideo>
</template>

<script>
import { mapGetters } from 'vuex';
import VePlayerVideo from '@/components/ve-player.vue';
import TCVideo from '@/components/tc-video.vue';
import TCVideoV1 from '@/components/tc-video-v1.vue';
import VideoToast from '@/components/tai-xiu/video-toast.vue';
import { getStreamPlayerKind } from '@/utils/stream-player';

/*
 * Picks the cockfight stream backend for a desktop pane, by the same rule as the
 * Tài Xỉu pane's video (`getStreamPlayerKind`, utils/stream-player.ts):
 * streamv=3 or none -> VePlayer, streamv=1 -> TCPlayer v1, streamv=2 -> VePlayer +
 * canvas. It mirrors `pages/cock-fight.vue` (minus its `mobileVePlayerFallback`,
 * which cannot be true in the desktop client).
 */
export default {
  name: 'CockfightVideo',
  components: {
    VePlayerVideo,
    TCVideo,
    TCVideoV1,
    VideoToast,
  },
  props: {
    /*
     * The arena this pane is showing. Forwarded explicitly (not left to
     * attribute fallthrough) so the player binds to this arena's stream rather
     * than the shared most-recent one -- without it both desktop panes render
     * the same feed.
     */
    arenaId: {
      type: String,
      default: '',
    },
    videoPlayerReady: {
      type: Boolean,
      default: true,
    },
    isAnyPopupOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      streamVersion: 'general/streamVersion',
      // The pane's own `bets` (scoped store, store/cockfight-pane.ts).
      betVideoToast: 'bets/videoToast',
    }),
    playerKind() {
      return getStreamPlayerKind(this.streamVersion);
    },
    isUsingVePlayer() {
      return this.playerKind === 'veplayer';
    },
    isUsingV1Video() {
      return this.playerKind === 'tcplayer';
    },
  },
};
</script>
